// Returns format 1.234 kr
export default function formatPrice(number, currencySymbol = "kr") {
  return `${number.toLocaleString("sv-SE", {
    style: "decimal",
    maximumFractionDigits: 0
  })} ${currencySymbol}`;
}
